module.exports = __webpack_public_path__ + "img/check_one.3a663cf1.svg";